import React from 'react'

const Social = () => {
    return (
        <>
            <div className="slinks d-flex mt-4 pt-2">
                <div className="link">
                    <a href="https://t.me/venkatesh_7975" target="_blank" rel='noreferrer'><i className="fa-brands fa-telegram"></i></a>
                </div>
                <div className="link">
                    <a href="https://www.linkedin.com/in/venkatesh_moyya/" target="_blank" rel='noreferrer'><i className="fa-brands fa-linkedin"></i></a>
                </div>
                <div className="link">
                    <a href="https://github.com/venkatesh7975" target="_blank" rel='noreferrer'><i className="fa-brands fa-github"></i></a>
                </div>
            </div>
        </>
    )
}

export default Social